import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Chart from "chart.js/auto";

const LineBarChart = ({ title, dataPoints, height = "20rem" }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        if (!dataPoints || dataPoints.length === 0) return;

        const ctx = chartRef.current.getContext("2d");

        if (window.birthChart) window.birthChart.destroy();

        const labels = dataPoints.map((d) => d.district);
        const male = dataPoints.map((d) => d.male);
        const female = dataPoints.map((d) => d.female);
        const lbw = dataPoints.map((d) => d.lbw);

        window.birthChart = new Chart(ctx, {
            type: "bar",
            data: {
                labels,
                datasets: [
                    {
                        label: "Total Births",
                        data: male,
                        backgroundColor: "rgba(59,130,246,0.7)", 
                        borderRadius: 6,
                        barThickness: 14,
                    },
                    // {
                    //     label: "Female Births",
                    //     data: female,
                    //     backgroundColor: "rgba(236,72,153,0.7)", 
                    //     borderRadius: 6,
                    //     barThickness: 14,
                    // },
                    {
                        label: "LBW (%)",
                        data: lbw,
                        type: "line",
                        yAxisID: "y1",
                        borderColor: "#22c55e",
                        backgroundColor: "rgba(34,197,94,0.2)",
                        fill: false,
                        tension: 0.4,
                        borderWidth: 2,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: "index", intersect: false },

                scales: {
                    x: {
                        ticks: { color: "#64748b", font: { size: 11 } },
                        grid: { display: false },
                    },
                    y: {
                        beginAtZero: true,
                        ticks: { color: "#475569", font: { size: 11 } },
                        title: { display: true, text: "Live Births", color: "#475569" },
                        grid: { color: "#f1f5f9" },
                    },
                    y1: {
                        position: "right",
                        beginAtZero: true,
                        ticks: {
                            color: "#3a4f61",
                            font: { size: 11 },
                            callback: (val) => `${val}%`,
                        },
                        title: { display: true, text: "LBW (%)", color: "#3a4f61" },
                        grid: { drawOnChartArea: false },
                    },
                },

                plugins: {
                    legend: {
                        position: "bottom",
                        labels: {
                            color: "#334155",
                            boxWidth: 12,
                            font: { size: 12, family: "Inter" },
                        },
                    },
                    tooltip: {
                        backgroundColor: "#fff",
                        titleColor: "#000",
                        bodyColor: "#000",
                        borderColor: "#e2e8f0",
                        borderWidth: 1,
                        padding: 10,
                        displayColors: true,
                        usePointStyle: true,
                        callbacks: {
                            label: function (ctx) {
                                const label = ctx.dataset.label || "";
                                const value = ctx.parsed.y;
                                return label === "LBW (%)" ? `${label}: ${value}%` : `${label}: ${value}`;
                            },
                        },
                    },
                    datalabels: {
                        display: false,
                    },
                },
            },
        });
    }, [dataPoints]);

    return (
        <div className="bg-white rounded-2xl shadow-md p-6 w-full">
            <h5 className="text-base font-semibold text-slate-800 mb-2">{title}</h5>

            {/* Dynamic Height */}
            <div style={{ height }}>
                <canvas ref={chartRef}></canvas>
            </div>
        </div>
    );
};

LineBarChart.propTypes = {
    title: PropTypes.string.isRequired,
    dataPoints: PropTypes.arrayOf(
        PropTypes.shape({
            district: PropTypes.string.isRequired,
            male: PropTypes.number.isRequired,
            female: PropTypes.number.isRequired,
            lbw: PropTypes.number.isRequired,
        })
    ).isRequired,
    height: PropTypes.string,
};

export default LineBarChart;
